<template>
  <div>
    <div class="reviews-sidebar-map-data-card">
      <span class="reviews-sidebar-map-data-card-subtitle"
        >Avaliações nas principais plataformas</span
      >
      <div class="reviews-sidebar-map-data-card-content">
        <div class="reviews-sidebar-map-data-card-left-content">
          <img src="/review-shop.svg" alt="Avaliação" />
          <div class="reviews-sidebar-map-data-card-subcontent">
            <span
              style="
                display: inline-block;
                margin-bottom: 10px;
                font-size: 0.875rem;
                font-weight: 600;
              "
            >
              <i class="fa-solid fa-star"></i>{{ averageRating }}</span
            >
            <span style="font-size: 0.875rem; font-weight: 400; color: #545f65"
              >{{ totalReviews }} avaliações</span
            >
          </div>
        </div>
        <div class="reviews-sidebar-map-data-card-right-content">
          <div class="subcontent">
            <span :style="{ color: parseSentimentColor(2) }" class="avarage-rating-title">{{
              averageRating
            }}</span>
            <span class="avarage-rating-text">Médias das avaliações</span>
          </div>
          <div
            style="
              height: 1px;
              width: 100%;
              border: 1px solid #e6e9eb;
              border-radius: 18px;
              margin: 10px 0;
            "
          ></div>
          <div class="subcontent">
            <span class="avarage-rating-text">Sentimento geral:</span>
            <span
              :style="{ color: parseSentimentColor(averageRating) }"
              style="font-size: 12px; font-weight: 600"
            >
              <font-awesome-icon
                :icon="parseSentimentIcon(averageRating)"
                style="margin-right: 7px; margin-top: 6px"
                size="lg"
              />
              {{ parseSentiment(averageRating) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reviewData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      averageRating: this.reviewData.rating || 0,
      totalReviews: this.reviewData.review_count || 0,
    }
  },
  methods: {
    parseSentimentColor(rating) {
      if (rating < 2) {
        return '#F25362'
      }
      if (rating >= 4) {
        return '#0B8C0B'
      }
      return '#FFC700'
    },

    parseSentiment(rating) {
      if (rating < 2) {
        return 'Negativo'
      }
      if (rating >= 4) {
        return 'Positivo'
      }
      return 'Neutro'
    },
    parseSentimentIcon(rating) {
      if (rating < 2) {
        return 'fa-regular fa-face-tired'
      }
      if (rating >= 4) {
        return 'fa-regular fa-face-meh'
      }
      return 'fa-regular fa-face-smile'
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
